<template>
  <section>
    <v-container fluid grid-list-md>
      <page-title :title="getTitle" />
      <v-layout row wrap class="mt-4">
        <v-flex md6>
          <v-text-field
            v-model="q"
            clearable
            :label="$t('tabelle.cerca')"
            type="text"
            @keyup.native.enter="search"
          />
        </v-flex>
        <v-flex md3>
          <v-btn color="primary" @click="search" :disabled="!q">
            <v-icon>search</v-icon> {{ $t('tabelle.cta1') }}
          </v-btn>
          <v-btn @click="resetSearch" v-if="hasSearched"> <v-icon>undo</v-icon> {{ $t('tabelle.cta2') }} </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-md class="pt-0">
      <v-layout row wrap justify-center v-if="pagination && pagination.pageCount > 1" class="mb-3">
        <v-pagination v-model="page" :length="pagination.pageCount"></v-pagination>
      </v-layout>
      <v-layout row wrap>
        <v-flex>
          <v-list>
            <template v-for="(tenant, index) in items">
              <v-divider v-if="index > 0" inset :key="'divider-' + index" />
              <v-list-tile :key="tenant.id_tenant" avatar :href="tenant.sheet" target="_blank">
                <v-list-tile-content>
                  <v-list-tile-title style="display: inherit"
                    >{{ tenant.i18n_name[tenant.default_lang] }}
                    <span class="material-symbols-outlined" style="margin-left: 1rem;  font-size: 1.3rem;">
                      open_in_new
                    </span></v-list-tile-title
                  >
                  <v-list-tile-sub-title>{{ tenant.business_id }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center v-if="pagination && pagination.pageCount > 1" class="mt-3">
        <v-pagination v-model="page" :length="pagination.pageCount"></v-pagination>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import pageTitle from '@/components/common/PageTitle';
import { $EventBus } from '@/eventBus';
import _union from 'lodash/union';
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    pagination: null,
    items: [],
    total: null,
    hasSearched: null,
    limit: 12,
    page: 1,
    q: null, // chiave di ricerca
  }),
  components: {
    pageTitle,
  },
  watch: {
    '$route.query'(newValue, oldValue) {
      if (newValue.page) {
        this.page = +newValue.page;
      } else {
        this.page = 1;
      }
      this.q = newValue.q;
      this.getList();
    },
    page(newValue) {
      if (newValue !== +this.$route.query.page) {
        this.$router.push({ path: '/sheets', query: { ...this.$route.query, page: newValue } });
      }
    },
  },
  computed: {
    ...mapGetters({
      userTenants: 'user/tenants',
    }),
    getTitle() {
      return this.$i18n.locale == 'it'? (this.userTenants?.length > 1? this.$t('menu.tabella') + 'e' : this.$t('menu.tabella') + 'a') : (this.userTenants?.length > 1? this.$t('menu.tabella') + 's' : this.$t('menu.tabella'))
    },
  },
  methods: {
    getList() {
      const query =
        {
          q: this.q,
          page: this.page,
          limit: this.limit,
        } || {};
      this.$http({
        method: 'get',
        url: '/tenants/me',
        params: query || {},
      })
        .then((response) => {
          this.total = response.data.total;
          this.items = response.data.items;
          this.pagination = response.data.pagination;
          this.page = response.data.pagination.page;
        })
        .catch((err) => {
          console.log('lista get error', err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.tables.list') });
        });
    },
    refresh() {
      this.getList();
    },
    resetSearch() {
      this.hasSearched = null;
      this.$router.push({ path: '/sheets', query: {} });
    },
    search() {
      const searchObject = {
        q: this.q,
        page: '1',
      };
      if (_.isEqual(_.pick(this.$route.query, ['q', 'page']), searchObject)) {
        this.getList();
      } else {
        this.$router.push({
          path: '/sheets',
          query: {
            ...this.$route.query,
            ...searchObject,
          },
        });
      }
      this.hasSearched = true; // per ostrare il reseset
    },
    loadMore() {
      this.getList(true);
    },
  },
  mounted() {
    this.q = this.$route.query.q;
    if (this.$route.query.page) {
      this.page = +this.$route.query.page;
    }
    this.getList();
  },
};
</script>
